<!-- <div class="progess-container">
  <div class="progess-container-wrapper">
      <ul >
        <li >

        </li>
      </ul>
  </div>
</div> -->
<!-- <div class="file-upload-noification">
<div class="notification-three">
    <i class="icon-angle-down"></i>
    <h1>Title1</h1>
    <p><ngb-progressbar value="500" type="info"></ngb-progressbar></p>
    <i class="icon-cira"></i>
    <p>status description</p>
  </div>
  <div class="notification-three">
      <i class="icon-angle-down"></i>
      <h1>Title2</h1>
      <p><ngb-progressbar value="500" type="info"></ngb-progressbar></p>
      <i class="icon-cira"></i>
      <p>status description</p>
    </div>
  </div> -->

<div class="file-upload-noification">
  <app-notification></app-notification>
  <div *ngIf="progessList.length">
      <app-progress-bar *ngFor="let progess of progessList" [ngStyle]="{'display':progess.show ? 'block' : 'none' }" [progress]=progess></app-progress-bar>
  </div>
</div>
